import { render } from "./FileNot.vue?vue&type=template&id=310ad03b&scoped=true"
import script from "./FileNot.vue?vue&type=script&lang=js"
export * from "./FileNot.vue?vue&type=script&lang=js"

import "./FileNot.vue?vue&type=style&index=0&id=310ad03b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310ad03b"]])

export default __exports__